import React from 'react';

import MappingsConfirmationDialog from 'atoms/MappingsConfirmationDialog';

interface Props {
  onNext: () => void;
  open: boolean;
}

function BeforeYouMap({ onNext, open }: Props) {
  return (
    <MappingsConfirmationDialog
      open={open}
      onNext={onNext}
      title="Before You Map"
      content={
        <>
          We’ve taken a look at your source data and have suggested some mappings to get you
          started. Review your mappings and make any changes or additions necessary before
          proceeding. If there are any <strong>required</strong> issues to address, you’ll see them
          outlined on the right-hand side of the page.
        </>
      }
    />
  );
}

export default BeforeYouMap;
